import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem, { fieldLang, getFieldWithLangKey, getNewObjFromDirtyLangObj } from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.PAGEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.PAGEFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.PAGEFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`ui/${params.id}`)
    item = { ...item, ...getFieldWithLangKey({ fieldTitle: 'title', objString: item.title, languages: fieldLang }) }
    dispatch({
      type: ActionTypes.PAGEFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(item)
    dispatch({
      type: ActionTypes.PAGEFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.PAGEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.PAGEFORM_CREATEITEM_LOAD })
  try {
    await api.create(`ui`, params)
    dispatch({ type: ActionTypes.PAGELIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.PAGEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.PAGEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.PAGEFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.PAGEFORM_EDITITEM_LOAD })
  try {
    await api.patch(`ui/${params.id}`, {
      ...getNewObjFromDirtyLangObj({ fieldTitle: 'title', languages: fieldLang, obj: params }),
    })
    dispatch({ type: ActionTypes.PAGEFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.PAGEFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.PAGEFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`ui/${params.id}`)
    dispatch({ type: ActionTypes.PAGEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.PAGEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.PAGEFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
